import config, {axiosConfig} from "../config";
import {CalculatedMTPLDuration} from "../model/duration";
import {default as axios} from "./axiosConfig";

interface Params {
	startDate: string,
	requiredTO: boolean,
	nextToDate?: string 
}

export async function calculateMTPLDuration({
	startDate,
	requiredTO,
	nextToDate
}: Params) {
	const {data} = await axios.post<CalculatedMTPLDuration>(`${config.API_URL}/mtpl/duration/calculate`,
		{
			startDate,
			requiredTO,
			nextToDate
		}, axiosConfig);

	return data;
}
